import React from "react";
import { Row, Col } from "react-bootstrap";

const CardHeader = ({ title, modal }: { title: String; modal?: any }) => {
  return (
    <>
      {/* <Row className="px-0"> */}
        <Col sm={9} className="desk">
          <h3 style={styles.title}>{title}</h3>
        </Col>
        <Col xs={9} className="ps-0 mob">
          <h3 style={styles.title}>{title}</h3>
        </Col>
        {modal && (
          <>
            <Col
              lg={3}
              md={3}
              sm={3}
              style={{ textAlign: "right" }}
              className="desk"
            >
              {modal}
            </Col>

            <Col
              lg={3}
              md={3}
              sm={3}
              xs={3}
             
              className="mob px-0"
            >
              {modal}
            </Col>
          </>
        )}
      {/* </Row> */}
    </>
  );
};

const styles: any = {
  viewlink: {
    float: "right",
  },

  viewlinkmob: {
    float: "right",
    MarginLeft: "26px",
    MarginTop: "-38px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "500",
  },
};

export default CardHeader;
